import React from 'react';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import './entitlement-loader.scss';

export const EntitlementLoader = () => {
  return (
    <div className="entitlement-loader">
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="15%" marginBottom="1.5rem" />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="27%" />
        <SkeletonLoader width="6%" />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader height="600px" />
      </SkeletonLoaderWrapper>
    </div>
  );
};
